"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckBox_1 = __importDefault(require("@mui/icons-material/CheckBox"));
var CheckBoxOutlineBlank_1 = __importDefault(require("@mui/icons-material/CheckBoxOutlineBlank"));
require("../../scss/_forms.scss");
/**
 * @component Checkbox
 * @example
 * return (
 *   <Checkbox
 *     checked={isChecked}
 *     id={client.clientId}
 *     label={client.clientName}
 *     name={client.clientName}
 *     onChange={() => {}}
 *   />
 * )
 *
 * @param {number | string} id formik id of the checkbox
 * @param {string} name name of checkbox, required for formik
 * @param {string} label checkbox label
 * @param {boolean} disabled is the checkbox clickable?
 * @param {function} onChange function for what happens when checkbox is clicked
 * @param {boolean} checked is the checkbox checked?
 * @param {number} marginTop margin on the top of the checkbox
 * @param {number} marginBottom margin at the bottom of the checkbox
 */
var Checkbox = function (props) {
    var id = props.id, name = props.name, label = props.label, disabled = props.disabled, onChange = props.onChange, _a = props.checked, checked = _a === void 0 ? false : _a, _b = props.marginTop, marginTop = _b === void 0 ? 2 : _b, _c = props.marginBottom, marginBottom = _c === void 0 ? 2 : _c;
    return (react_1.default.createElement("label", { className: "checkbox mt-".concat(marginTop, " mb-").concat(marginBottom), htmlFor: "checkbox-".concat(id) },
        react_1.default.createElement("input", { id: "checkbox-".concat(id), name: name, type: "checkbox", disabled: disabled, checked: checked, onChange: onChange }),
        react_1.default.createElement("span", { className: "checkbox-on ".concat(disabled ? "disabled" : "") },
            react_1.default.createElement(CheckBox_1.default, null)),
        react_1.default.createElement("span", { className: "checkbox-off ".concat(disabled ? "disabled" : "") },
            react_1.default.createElement(CheckBoxOutlineBlank_1.default, null)),
        react_1.default.createElement("span", { className: "label ".concat(disabled ? "disabled" : "") }, label)));
};
exports.default = Checkbox;
